import { lazy } from 'react';

const lazyComponent = (name) => {
  const Component = lazy(() => import(`components/${name}/${name}`));

  return <Component />;
};

export const ROUTES_PATHS = {
  home: '/home',
  tracking: 'home/:id',
  about: '/about',
  contact: '/contact',
  policy: '/policy',
  notFound: '/not-found',
};

export const ROUTES = [
  { path: ROUTES_PATHS.home, element: lazyComponent('Home') },
  { path: ROUTES_PATHS.tracking, element: lazyComponent('Tracking') },
  { path: ROUTES_PATHS.about, element: lazyComponent('About') },
  { path: ROUTES_PATHS.contact, element: lazyComponent('Contact') },
  { path: ROUTES_PATHS.policy, element: lazyComponent('Policy') },
  { path: ROUTES_PATHS.notFound, element: lazyComponent('NotFound') },
];
